const calculateTimeDifference = (startDate: Date, endDate: Date) => {
  var start = new Date(startDate);
  var end = new Date(endDate);
  var s = (end.getTime() - start.getTime()) / 1000;

  var days = Math.floor(s / (3600 * 24));
  var hours = Math.floor((s % (3600 * 24)) / 3600);
  var minutes = Math.floor((s % 3600) / 60);
  var seconds = Math.floor((s % 3600) % 60);

  var dDisplay = days > 0 ? days + (days === 1 ? " day, " : " days, ") : "";
  var hDisplay =
    hours > 0 ? hours + (hours === 1 ? " hour, " : " hours, ") : "";
  var mDisplay =
    minutes > 0 ? minutes + (minutes === 1 ? " minute" : " minutes") : "";
  var sDisplay =
    minutes < 1 && hours < 1 && days < 1
      ? seconds + (seconds === 1 ? " second" : " seconds")
      : "";

  return dDisplay + hDisplay + mDisplay + sDisplay;
};

export default calculateTimeDifference;
